export enum MODAL_MESSAGE {
    DELETE_PARA_1 = 'This product has one or more options associated with it, and deleting it will break these relationships.',
    DELETE_PARA_2 = 'Are you sure you want to delete this product?',
    MOVE_PARA_1 = 'This product has one or more options associated with it, and changing its section will break these relationships.',
    MOVE_PARA_2 = 'Are you sure you want to proceed?'
}
